export class ItemViewModel {
  text: string;
  value: string;
  disabled: boolean;

  constructor(text: string = '', value: string = '', disabled: boolean = false) {
    this.text = text;
    this.value = value;
    this.disabled = disabled;
  }
}
